import authService from "../../services/AuthService";
import { buildCQLFilter } from "../../services/MapCore/MapCQLFilterService";
import { DefaultLayer } from "./DefaultLayer";

class WmsLayer extends DefaultLayer {
  constructor(layer_data, layer_group_id) {
    super(layer_data, layer_group_id);

    this.id = this.id.replace(layer_data.uuid, `wms-${layer_data.uuid}`);
  }

  getFeatureInfoOnClick = (evt, map) => {
    const layer = this.layer;
    const layer_data = this.layer_data;

    const { geoserver_layer_id } = layer_data;

    const source = layer.getSource();
    const url = source.getFeatureInfoUrl(
      evt.coordinate,
      map.getView().getResolution(),
      "EPSG:4326",
      {
        INFO_FORMAT: "application/json",
        QUERY_LAYERS: geoserver_layer_id,
        FEATURE_COUNT: 99,
        CQL_FILTER: buildCQLFilter(this.filters),
      }
    );

    if (!url) {
      console.error("No se pudo generar la URL de GetFeatureInfo para WMS.");
      return [];
    }

    return fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Bearer ${authService.getToken()}`,
      },
    })
      .then((response) => response.json())
      .then((data) => data.features || [])
      .catch((error) => {
        console.error(
          "Error al obtener la información de la feature WMS:",
          error
        );
        return [];
      });
  };
}

export { WmsLayer };
